export * from './full-layout.component';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/containers/full-layout/index.ts